export default __webpack_public_path__ + "static/media/cancel-light.acf4a5d4.svg";